import { Button } from './Button'

type Props = {
  placeholder: string
  value: string
  autoFocus?: boolean
  onChange?: (value: string) => void
  onClickCancel?: () => void
  onClickAdd?: () => void
}
export function CommentComposer({
  placeholder,
  value = '',
  onChange,
  onClickCancel,
  onClickAdd,
  autoFocus
}: Props) {
  return (
    <div className="flex flex-col items-stretch gap-2 rounded-sm bg-white p-3 shadow-sm">
      <textarea
        className="resize-none p-2 text-base text-gray-900"
        placeholder={placeholder}
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      />
      <div className="flex flex-row justify-end gap-3">
        <Button variant="subtle" onClick={() => onClickCancel?.()}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => onClickAdd?.()}>
          Save
        </Button>
      </div>
    </div>
  )
}
